module.exports = __webpack_public_path__ + "static/media/git.e51fbde9.svg";